import React from 'react';

import { useLocation } from 'react-router-dom';

import TestHomeView from './view';
import InnerSidebarNavigation from '@components/InnerSidebarNavigation';
import GoBackArrow from '@assets/sidebarNavigation/goBackArrow.png';
import QuestionMark from '@assets/sidebarNavigation/questionMark.png';
import EditPencilIcon from '@assets/common/editPencilIcon.png';


function ExamHome() {
	const location = useLocation();

	//Failsafe if no data received from navigation
	let navigationData = [
		{
			title: 'Back to Tests',
			route: '/content?tab=tests',
			icon: GoBackArrow,
		},
		{
			title: 'Details',
			"component" : "TestDetails",
			icon: EditPencilIcon,
		},
		{
			title: 'Question',
			"component" : "TestQuestions",
			icon: QuestionMark,
		},
	];
	
	if (location.state && location.state.navigationData) {
		navigationData = location.state.navigationData;
	}
	return (
		<>
			<InnerSidebarNavigation navigationData={navigationData} />
			<TestHomeView />
		</>
	);
}

export default ExamHome;
